import React, { useMemo } from 'react';
import clsx from 'clsx';

export interface TextProps {
    variant?:
        | 'display-large'
        | 'display-medium'
        | 'display-small'
        | 'heading-large'
        | 'heading-medium'
        | 'heading-small'
        | 'title-large'
        | 'title-medium'
        | 'title-small'
        | 'body-large'
        | 'body-medium'
        | 'body-small'
        | 'label-large'
        | 'label-medium'
        | 'label-small';
    align?: 'start' | 'center';
    numberOfLines?: number;
    children: React.ReactNode;
    id?: string;
    className?: string;
}

export const Text: React.FC<TextProps> = ({ variant, align, numberOfLines, children, id, className }) => {
    const classByVariant = useMemo(() => {
        const lineClampClass = numberOfLines ? `line-clamp-${numberOfLines}` : 'line-clamp-none';
        const alignClass = align === 'center' ? 'text-center' : 'text-start';

        const variantClassMap = {
            'display-large': 'text-display-large font-condensed uppercase font-bold',
            'display-medium': 'text-display-medium font-condensed uppercase font-bold',
            'display-small': 'text-display-small font-condensed uppercase font-bold',

            'heading-large': 'text-heading-large font-condensed font-bold',
            'heading-medium': 'text-heading-medium font-condensed font-bold',
            'heading-small': 'text-heading-small font-condensed font-bold',

            'title-large': 'text-title-large font-sans font-bold',
            'title-medium': 'text-title-medium font-sans font-bold',
            'title-small': 'text-title-small font-sans font-bold',

            'body-large': 'text-body-large font-sans font-normal',
            'body-medium': 'text-body-medium font-sans font-normal',
            'body-small': 'text-body-small font-sans font-normal',

            'label-large': 'text-label-large font-sans font-medium',
            'label-medium': 'text-label-medium font-sans font-medium',
            'label-small': 'text-label-small font-sans font-medium',
        };

        return clsx(variantClassMap[variant || 'body-medium'], lineClampClass, alignClass);
    }, [variant, align, numberOfLines]);

    return (
        <p className={`${classByVariant} ${className}`} data-testid={id}>
            {children}
        </p>
    );
};
